import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars, faBrain, faNetworkWired, faWifi, faBolt,
  faPhone, faVideo, faHome, faCity, faCog, faUsers,
  faQuestion, faNewspaper, faTimes, faStoreAlt, faFileContract, faTv
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import styles from '../css/comuns/Header.module.css';
import { config } from '../../data';
import { Link } from 'react-router-dom';  


const Header = () => {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isMobileNavActive && !event.target.closest(`.${styles['mobile-nav']}`) && !event.target.closest(`.${styles['abrir-menu']}`)) {
        setIsMobileNavActive(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isMobileNavActive]);

  const toggleMobileNav = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };

  return (
    <>
      <header>
        {/* Top Bar */}
        <div className={styles['top-bar']}>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-auto d-lg-none">
                <button className={styles['abrir-menu']} onClick={toggleMobileNav}>
                  <FontAwesomeIcon icon={faBars} />
                </button>
              </div>
              <div className="col d-none d-lg-block">
                <nav className={styles['top-nav']}>
                  <Link to="/Quemsomos">
                    <FontAwesomeIcon icon={faBrain} /> {config.texts.header.topNav.discover}
                  </Link>
                  <span className={styles.separator}>|</span>
                  <a href="/ParaEmpresas"><FontAwesomeIcon icon={faNetworkWired} /> {config.texts.header.topNav.empresas}</a>
                  <span className={styles.separator}>|</span>
                  <a href="/ParaEmpresas"><FontAwesomeIcon icon={faWifi} /> {config.texts.header.topNav.condominios}</a>
                  <span className={styles.separator}>|</span>
                  <a href="/perguntasfrequentes"><FontAwesomeIcon icon={faBolt} /> {config.texts.header.topNav.tecnologia}</a>
                </nav>
              </div>
              <div className="col-auto">
                <div className={styles['top-right-icons']}>
                  <a href={config.links.external.centralAssinante} className={`${styles.button} ${styles['central-assinante']} d-none d-lg-inline-block`}>{config.texts.header.buttons.centralAssinante}</a>
                  <a href={config.links.social.whatsapp}><FontAwesomeIcon icon={faWhatsapp} /></a>
                  <a href={config.links.social.instagram}><FontAwesomeIcon icon={faInstagram} /></a>
                  <a href={config.links.social.facebook}><FontAwesomeIcon icon={faFacebook} /></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className={styles['main-header']}>
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-auto">
                <div className={styles.logo}>
                 <Link to="/"><img src={config.images.logos.header} alt={config.company.name} /> </Link>
                </div>
              </div>
              <div className="col d-none d-lg-block">
                <nav className={styles['main-nav']}>
                  <a href="/Planos">{config.texts.header.mainNav.planos}</a>
                  <a href="/Entretenimento">{config.texts.header.mainNav.entretenimento}</a>
                  <a href="/Internet">{config.texts.header.mainNav.internet}</a>
                  <Link to="/Ofertaschips">{config.texts.header.mainNav.telefonia}</Link>
                </nav>
              </div>
              <div className="col-auto d-none d-lg-block">
                <div className={styles['header-buttons']}>
                  <a href="/pagar-fatura" className={`${styles.button} ${styles['pagar-fatura']}`}>{config.texts.header.buttons.pagarFatura}</a>
                  <a href={config.links.external.assineAgora} className={`${styles.button} ${styles['assine-agora']}`}>{config.texts.header.buttons.assineAgora}</a>
                  <a href={`tel:${config.links.phones.support}`} className={styles['phone-number']}><FontAwesomeIcon icon={faPhone} /> {config.links.phones.supportFormatted}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Navigation */}
      <nav className={`${styles['mobile-nav']} ${isMobileNavActive ? styles.active : ''}`}>
        <button className={styles['close-menu']} onClick={toggleMobileNav}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <img src={config.images.logos.main} alt={config.company.name} className={styles['logo-mobile']} />
        <a href="/" className={styles['menu-item']}><FontAwesomeIcon icon={faHome} /> {config.texts.header.mobileNav.inicio}</a>
        <a href="/Planos" className={styles['menu-item']}><FontAwesomeIcon icon={faFileContract} /> {config.texts.header.mobileNav.planos}</a>
        <a href="/Entretenimento" className={styles['menu-item']}><FontAwesomeIcon icon={faTv} /> {config.texts.header.mobileNav.entretenimento}</a>
        <a href="/internet" className={styles['menu-item']}><FontAwesomeIcon icon={faWifi} /> {config.texts.header.mobileNav.internet}</a>
        <Link to="/Ofertaschips" className={styles['menu-item']}><FontAwesomeIcon icon={faPhone} /> {config.texts.header.mobileNav.telefonia}</Link>
        <a href="/ParaEmpresas" className={styles['menu-item']}><FontAwesomeIcon icon={faStoreAlt} /> {config.texts.header.mobileNav.empresas}</a>
        <a href="/ParaEmpresas" className={styles['menu-item']}><FontAwesomeIcon icon={faCity} /> {config.texts.header.mobileNav.condominios}</a>
        <a href={config.links.external.centralAssinante} className={styles['menu-item']}><FontAwesomeIcon icon={faCog} /> {config.texts.header.mobileNav.centralAssinante}</a>
        <Link to="/Quemsomos" className={styles['menu-item']}><FontAwesomeIcon icon={faUsers} /> {config.texts.header.mobileNav.quemSomos}</Link>
        <a href="/perguntasfrequentes" className={styles['menu-item']}><FontAwesomeIcon icon={faQuestion} /> {config.texts.header.mobileNav.faq}</a>
        
        <div className={styles['mobile-icons']}>
          <a href={config.links.social.whatsapp} className={styles['icon-link']}><FontAwesomeIcon icon={faWhatsapp} /></a>
          <a href={config.links.social.instagram} className={styles['icon-link']}><FontAwesomeIcon icon={faInstagram} /></a>
          <a href={config.links.social.facebook} className={styles['icon-link']}><FontAwesomeIcon icon={faFacebook} /></a>
        </div>
      </nav>
    </>
  );
};

export default Header;